import type { CatalogItem } from '../types';

import { isRecentlyLaunched } from './isRecentlyLaunched';

/**
 * Counts how many catalog items were launched within the "recently launched"
 * window (see {@link isRecentlyLaunched}). `now` is injected for deterministic
 * tests.
 */
export const countRecentlyLaunched = (
  items: Pick<CatalogItem, 'LaunchDate'>[],
  now: Date
): number => items.filter(item => isRecentlyLaunched(item.LaunchDate, now)).length;
